<template>
  <div class="sync">
    <el-dialog
      :close-on-click-modal="false"
      title="TikTok同步产品"
      width="500px"
      :visible.sync="visible"
      :before-close="handleClose"
    >
      <div style="margin:20px 0 0px 20px;font-size:14px;">
        已选商品<span style="color:red;margin: 0 2px;">{{
          this.data.length
        }}</span
        >件
      </div>
      <div style="font-size:14px;margin: 20px 0;">
        <el-form ref="form" label-width="100px" :model="form">
          <el-form-item
            :rules="[
              { required: true, message: '请选择内容', trigger: 'change' },
            ]"
            prop="syncMode"
            label="同步模式："
          >
            <el-radio v-model="form.syncMode" label="1">立即同步</el-radio>
            <el-radio v-model="form.syncMode" label="2">定时同步</el-radio>
          </el-form-item>
          <el-form-item
            v-if="syncMode == '2'"
            :rules="[
              { required: true, message: '请选择内容', trigger: 'change' },
            ]"
            prop="dateTime"
            label="同步时间："
          >
            <el-date-picker
              size="small"
              v-model="form.dateTime"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptionsNew"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              style="width:100%;"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            v-if="syncMode == '2'"
            :rules="[
              { required: true, message: '请输入内容', trigger: 'change' },
            ]"
            prop="num"
            label="每天同步："
          >
            <el-input-number
              size="small"
              v-model="form.num"
              :min="1"
              label=""
            ></el-input-number>
            件
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">返回</el-button>
        <el-button type="primary" @click="sureImport" size="small">
          上传
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { syncOrder } from "@/api/order/all"
import {
  getShopList,
  syncTiktok,
  getChannelList,
  templateTiming,
} from "@/api/shop/shop"

export default {
  name: "SyncTiktok",
  data() {
    return {
      shopList: [],
      multipleSelection: [],
      percent: 0,
      loadingVisible: false,
      resultList: [],
      timer: null,
      successFlag: false,
      message: "数据可能延迟，请稍后刷新",
      showMessage: false,
      form: {
        shopId: "",
        remitId: "",
        channel: "",
        dateTime: [],
        syncMode: "1",
        num: "1",
      },
      options: [],
      pickerOptionsNew: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 3600 * 1000 
        },
      },
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    data: {
      type: Array,
      default() {
        return []
      },
    },
    syncMode: {
      type: String,
      default() {
        return "1"
      },
    },
  },
  watch: {
    visible() {
      if (this.visible) {
        this.showMessage = false
        this.successFlag = false
        this.percent = 0
        this.options = []
        this.form = {
          shopId: "",
          remitId: "",
          channel: "",
          dateTime: [],
          syncMode: "1",
          num: "1",
        }
        this.$nextTick(() => {
          this.$refs["form"].clearValidate()
        })
      }
    },
  },
  computed: {
    syncStatus() {
      return this.$store.state.product.syncStatus
    },
  },
  mounted() {
    this.getData()
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    getData() {
      getShopList({ platNo: "10" }).then((res) => {
        this.shopList = res.rows
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleClose() {
      this.$emit("onClose")
      this.$emit("update")
      this.loadingVisible = false
    },
    completeDate(value) {
      return value < 10 ? "0" + value : value
    },
    async sureImport() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          try {
            this.$emit("onClose")
            let form = this.form

            if (this.syncMode == "1") {
              this.$emit("onClose")
              this.events.$emit("showSyncHint", true)

              let syncResult = {
                total: this.data.length,
                success: 0,
                fail: 0,
                failList: [],
              }
              this.$store.commit("SET_SYNC_RESULT", syncResult)
              this.$store.commit("SET_SYNC_STATUS", true)

              for (let record of this.data) {
                let result = await syncTiktok({
                  remitId: record.remitId,
                  shopId: record.shopId,
                })

                let msg = result.msg
                let keys = []
                for (let key in this.$store.getters.dictMap["errorInfo"]) {
                  keys.push(key)
                }

                for (let record of keys) {
                  if (msg.toLowerCase().indexOf(record.toLowerCase()) > -1) {
                    msg = this.$store.getters.dictMap["errorInfo"][record]
                  }
                }

                if (result.data.isSuccess == "200") {
                  syncResult.success++
                }
                if (result.data.isSuccess == "500") {
                  syncResult.fail++
                  syncResult.failList.push({
                    designId: result.data.designId,
                    msg: msg,
                  })
                }
                this.$store.commit("SET_SYNC_RESULT", syncResult)
                if (!this.syncStatus) {
                  return
                }
              }
              this.$emit("update")
              this.msgSuccess("发布成功")
              this.events.$emit("showSyncHint", false)
            } else {
              let remitIds = []
              this.data.map((record) => {
                remitIds.push(record.remitId)
              })
              let result = await templateTiming({
                remitIds: remitIds.join(","),
                beginTime: form.dateTime[0],
                endTime: form.dateTime[1],
                num: form.num,
              })
              this.msgSuccess("定时同步成功")
              this.$emit("update")
            }
          } catch (error) {
            console.log(error)
            this.events.$emit("showSyncHint", false)
          }
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
.sync /deep/.el-table::before {
  display: none;
}
.sync-table {
  overflow-y: auto;
  max-height: 260px;
}
.status {
  margin: 10px 0;
}
.red {
  color: red;
}
.detail-wrap {
  max-height: 180px;
  overflow-y: auto;
}
.detail .list {
  padding: 5px 20px;
  box-sizing: border-box;
  width: 100%;
}
</style>
